module.exports = __webpack_public_path__ + "static/hand-painted-bg-0d55c02479fed57cf56d77bcedfe1458.jpg";